export default __webpack_public_path__ + "static/alphaq-abb2b79bea1c8250a0d6540a6e65fd93.jpeg";